import React from 'react'


export default class extends React.Component {

  render() {
    if(!this.props.logged_in) {
      return (
        <div className="full big accent">
          <div className="wrap content-text">
            <h2 className="cta-title">Begin vandaag</h2>
            <p style={{textAlign:"center"}}>Hou je gewicht bij, geef jezelf een doel, gebruik een eigen dagboek en meer. Deze basis is helemaal gratis, met enkel een emailadres ontdek je de voordelen van DieetClub.</p>
            {/*<div style={{textAlign:"center"}}><small style={{fontSize:"95%", fontWeight:"bold", margin:"2em 0 0"}}>Doe mee met 2.187 anderen!</small></div>*/}
            <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-e btn-fat">Start NU</button></div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="accent" style={{height:"7px"}}></div>
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/StartFooterCTA.js